module.exports = __webpack_public_path__ + "static/media/card_9.1697d0fa.jpg";